import React, { Component } from 'react';
import UserAvatar from './UserAvatar.js';

import './RoomInviteForm.css';

class RoomInviteForm extends Component {
  constructor(props) {
    super(props);

    // Flag for whether or not the drop zone is being dragged over by a user
    // right now.
    this.state = {
      isBeingDraggedOver: false,
      recipients: []
    };
  }

  /**
   * Handle onDragOver events for the drop zone.
   *
   * @memberof CreateRoomForm
   * @param SyntheticEvent The drag event.
   */
  handleDragOver = (e) => {
    this.setState({ isBeingDraggedOver: true });
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';

    return false;
  }

  /**
   * Handle onDragEnter events for the drop zone.
   *
   * @memberof CreateRoomForm
   * @param SyntheticEvent The drag event.
   */
  handleDragEnter = (e) => {
    this.setState({ isBeingDraggedOver: true });
  }

  /**
   * Handle onDragLeave events for the drop zone.
   *
   * @memberof CreateRoomForm
   * @param SyntheticEvent The drag event.
   */
  handleDragLeave = (e) => {
    this.setState({ isBeingDraggedOver: false });
  }

  handleDrop = (ev) => {
    // Attempt to fetch the user attached to the dropped object. If one doesn't exist,
    // don't try to accept it and return early.
    let data = ev.dataTransfer.getData('user');
    if (!data) {
      return;
    }

    // Otherwise, accept the drop.
    ev.stopPropagation();
    this.setState({ isBeingDraggedOver: false });

    // Handle dropping the user...
    let user = JSON.parse(data);
    this.addUser(user);

    return false;
  }

  addUser = (user) => {
    let { recipients } = this.state;
    recipients.push(user);

    this.setState({ recipients });
  }

  /**
   * Invite the current recipients to the room. Calls the passed in Redux action.
   *
   *
   * @memberof RoomInviteForm
   */
  inviteUsers = (ev) => {
    ev.preventDefault();
    const { room } = this.props;
    const { recipients } = this.state;

    this.props.onSubmit(room.id, recipients);
  }

  /**
   * Render out a friend cell for a given user object. Renders the circular cells that denote
   * who will be invited when the room is created.
   *
   * @memberof CreateRoomForm
   * @param Object The user object from the API to render.
   */
  renderUserCell = (user) => {
    return (
      <li className="CreateRoomForm__user-cell" key={user.id}>
        <UserAvatar user={user} />
        <span className="CreateRoomForm__user-cell-name">{user.displayName}</span>
      </li>
    );
  }

  render() {
    const { isBeingDraggedOver, recipients } = this.state;
    const { className, room, invitedToRoom, onFinish } = this.props;

    // If there's been a room created, return early with the success message.
    if (invitedToRoom) {
      let recipientNames = recipients.map((r) => r.displayName);
      return (
        <div className="RoomInviteForm">
          <h3>Invites sent!</h3>
          <p>We've sent your invite to {recipientNames.join(', ')}.</p>

          <button className="Button" onClick={this.props.close}>Done</button>
        </div>
      )
    }

    // Otherwise, assemble the room creation form.

    // Compute the help text for the drop zone (changes depending on if there's any items
    // being dragged over the form)..
    let dropzoneClasses = ['CreateRoomForm__dropzone'];
    let dropzoneText = 'To invite people to the room, drag them from your friends list on the left.';
    if (isBeingDraggedOver) {
      dropzoneClasses.push('is-drag-over');
      dropzoneText = 'Now drop to add the user!';
    }

    // Map through each invited user and render a cell for them.
    let recipientCells = recipients.map((user) => this.renderUserCell(user));

    let formClassNames = ['RoomInviteForm'];
    if (className) {
      formClassNames.push(className);
    }

    return (
      <form action="#" className={formClassNames.join(' ')} onSubmit={this.inviteUsers}>
        <ul className="CreateRoomForm__user-list">
          {recipientCells}
        </ul>

        <section className={dropzoneClasses.join(' ')}
          onDragOver={this.handleDragOver}
          onDragEnter={this.handleDragEnter}
          onDragLeave={this.handleDragLeave}
          onDrop={this.handleDrop}>
          <p className="CreateRoomForm__drop-help">{dropzoneText}</p>
        </section>

        <input type="submit" className="Button CreateRoomForm__submit" value="Invite" />
      </form>
    );
  }
}

export default RoomInviteForm;



// WEBPACK FOOTER //
// ./src/components/RoomInviteForm.js